import React, { useState } from 'react';
import Lottie from 'lottie-react';
import './WelcomePage.css';
import pandaAnimation from '../assets/animations/Panda Waving.json';

const WelcomePage = ({ onNavigateToCompanion }) => {
  const [isWiggling, setIsWiggling] = useState(false);

  const handlePandaClick = () => {
    if (!isWiggling) {
      setIsWiggling(true);
      // Reset wiggling after animation completes
      setTimeout(() => {
        setIsWiggling(false);
      }, 600);
    }
  };
  return (
    <div className="welcome-container">
      <div className="falling-leaves">
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
      </div>
      <div className="background-overlay"></div>
      
      <div className="content">
        <div className="header">
          <h1 className="app-title">MoodSync</h1>
          <p className="tagline">
            Why mood swing when you<br />
            have MoodSync!
          </p>
        </div>

        <div className="panda-container">
          <div 
            className={`lottie-animation ${isWiggling ? 'wiggling' : ''}`}
            onClick={handlePandaClick}
          >
            <Lottie 
              animationData={pandaAnimation} 
              loop={true}
              autoplay={true}
              style={{ width: 250, height: 250, cursor: 'pointer' }}
            />
          </div>
        </div>

        <button className="sync-button" onClick={onNavigateToCompanion}>
          Let's Sync
        </button>
      </div>
    </div>
  );
};

export default WelcomePage;